"use strict";
// Moved from Trackly.WebClient/src/services/VendorService/types.ts (T014).
// TypeScript types based on backend Vendor view models
Object.defineProperty(exports, "__esModule", { value: true });
